require('./cardSavingsReject.scss');

// @ vendors
const React = require('react');
import { withRouter } from 'react-router-dom';
const PropTypes = require('prop-types');

// @ helpers
const { formatAmountObject, getPlainAmountObject } = require('utilities/currencyHelper');
const { formatText, FormattedText, getLanguage } = require('core/i18n').i18n;

//@commons
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');
const { ContentBox } = require('commonsComponents/contentBox');
const { OKButton } = require('components/commons/OKButton/OKButton');
const PreLeaveModalComponent = require('components/preLeaveModalComponent/preLeaveModalComponent');

// @ constants
const {
    REJECT_MONEY_REQUEST_STATUS
} = require('constants/index');

class CardSavingsReject extends React.Component {
    constructor(props) {
        super(props);
        this.handleCardSavingsReject = this.handleCardSavingsReject.bind(this);
        this.isReady = this.isReady.bind(this);
    }

    handleCancel() {
        this.props.history.push(`/myprofile/global`);
    }

    handleCardSavingsReject() {
        const cardId = this.props.immCard.get('cardId');
        this.props.rejectMoneyRequestCall(cardId, REJECT_MONEY_REQUEST_STATUS);
    }

    isReady() {
        return false;
    }

    render() {
        const {
            immCard,
            amountRejected,
            beneficiary,
            isRejecting
        } = this.props;
        const currency = immCard.getIn(['extra', 'eCardInfo', 'saldoActualPrepago', 'divisa']);
        const amountObject = {amount: amountRejected, currency: currency};
        const plainAmountObject = getPlainAmountObject(amountObject);
        const acceptText = formatText('wizard-redirectConfirmationAcceptButton');
        const cancelText = formatText('wizard-redirectConfirmationCancelButton');
        const confirmationTitle = formatText('wizard-redirectConfirmationTitle');
        const confirmationMessage = formatText('wizard-redirectConfirmationMessage');
        const language = getLanguage();
        let content = (
            <div>
                <PreLeaveModalComponent
                    acceptText={acceptText}
                    confirmationMessage={confirmationMessage}
                    confirmationTitle={confirmationTitle}
                    cancelText={cancelText}
                    isReady={this.isReady}
                />
                <h1 className="card-savings-reject__title">
                    <FormattedText value="moneySavingsRequest-cancelSubtitle" />
                </h1>
                <FormattedText
                    className="card-savings-reject__sub-title"
                    value="moneySavingsRequest-cancelParagraph"
                />
                <div className="card-savings-reject__content">
                    <OKInformativeList columns={3}>
                        <OKInformativeListItem
                            title="moneySavingsRequest-cancelRequestAccountName"
                            bodyText={beneficiary}
                        />
                        <OKInformativeListItem
                            title="moneySavingsRequest-cancelRequestType"
                            bodyText={'moneySavingsRequest-acceptBreadcrumbText'}
                        />
                        <OKInformativeListItem
                            title="moneySavingsRequest-cancelRequestAmount"
                            className="account-settlements-info__value--last-one"
                        >
                            <OneLineSymbolAmount
                                className="account-settlements-info__value"
                                amountObject={plainAmountObject}
                                language={language}
                                amountObjectFormatted={formatAmountObject(plainAmountObject, true)}
                            />
                        </OKInformativeListItem>
                    </OKInformativeList>
                </div>
                <div className="card-savings-reject__separator" />
                <footer className="card-savings-reject__button text-right">
                    <div className="pull-left">
                        <OKButton modifier="link-ghost" onClick={() => this.handleCancel()}>
                            <FormattedText value="common-cancel" />
                        </OKButton>
                    </div>
                    <OKButton
                        onClick={this.handleCardSavingsReject}
                        loading={isRejecting}
                    >
                        <FormattedText value="transfersAgenda-removeBeneficiaryAction" />
                    </OKButton>
                </footer>
            </div>
        );

        return (
            <ContentBox
                id="rejectSavingsRequest"
            >
                {content}
            </ContentBox>
        );
    }
}

CardSavingsReject.propTypes = {
    amountRejected: PropTypes.number.isRequired,
    beneficiary: PropTypes.string.isRequired,
    cardId: PropTypes.string.isRequired,
    history: PropTypes.object.isRequired,
    immCard: PropTypes.object.isRequired,
    isRejecting: PropTypes.bool,
    rejectMoneyRequestCall: PropTypes.func.isRequired,
};

CardSavingsReject.defaultProps = {
    isRejecting: false
};

module.exports = withRouter(CardSavingsReject);
